import { Suspense, useCallback, useMemo } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { UserForm } from '@modules/Users/partials/UserForm';
import { useMe } from '@modules/Auth/hooks/useMe';
import { useUserCrud } from '@modules/Users/hooks/useUserCrud';

import { Logo } from '@shared/components/Logo';
import config from '@shared/config';

export const Onboarding = () => {

  const { user } = useMe();
  const { editUser } = useUserCrud();

  const hiddenFields = useMemo(() => {
    const fields: (keyof Users.Crud)[] = ['firstName', 'lastName', 'location', 'wantedDegreeLevel', 'uniLocalisationPreference'];

    return fields.reduce<(keyof Users.Crud)[]>((prev, curr) => {
      if (user && user[curr]) {
        return [...prev, curr];
      }
      return prev;
    }, ['type', 'email']);
  }, [user]);

  const onSubmit = useCallback((data: Users.Crud) => {
    if (!user) {
      return false;
    }
    return editUser({
      ...data,
      id: user.id,
    });
  }, [user, editUser]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading />}>
        <Container maxWidth="sm" sx={{ borderRadius: 0 }}>
          <Box py={3}>
            <Box mb={8} display="flex" justifyContent="center">
              <Logo style={{ width: 50, height: 50 }} alt={config.projectName}/>
            </Box>
            <Box mb={8} textAlign="center">
              <Typography
                variant="h1"
                fontSize={32}
                fontWeight={900}
                fontFamily="'Rubik', sans-serif"
                sx={{
                  background: '#FFF none repeat scroll 0 0',
                  boxDecorationBreak: 'clone',
                  display: 'inline',
                  px: 2,
                  py: 1,
                  lineHeight: 2,
                  boxShadow: '-10px 10px 0 #000',
                  border: '2px solid #000',
                }}
              >
                Complete Your Profile
              </Typography>
            </Box>
            <Box component={Paper} variant="elevation">
              <Box p={3}>
                {user && (
                  <UserForm
                    defaultValues={{
                      ...user,
                      location: user.location ? {
                        id: user.location.id,
                        name: user.location.title,
                        location: {
                          lat: user.location.latitude,
                          lng: user.location.longitude,
                        },
                      } : null,
                    }}
                    hiddenFields={hiddenFields}
                    onSubmitRequest={onSubmit}
                    onSubmitButtonText="Continue"
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Container>
      </Suspense>
    </ErrorBoundary>
  );
};
